import { ActorError } from '@sigma/actors-core/ActorError.js';
/**
 * Error thrown when an actor RPC request fails.
 *
 * This error is used specifically for individual request failures and includes
 * request-scoped metadata accessible via getters.
 */
export class ActorClientRequestError extends ActorError {
    /**
     * Gets the unique request identifier.
     */
    get requestId() {
        return this.data.requestId;
    }
    /**
     * Gets the actor key (type.id).
     */
    get actorKey() {
        return this.data.actorKey;
    }
    /**
     * Gets the actor type.
     */
    get actorType() {
        return this.data.actorType;
    }
    /**
     * Gets the request name.
     */
    get requestName() {
        return this.data.requestName;
    }
    /**
     * Gets the timestamp when the request was sent.
     */
    get sentAt() {
        return this.data.sentAt;
    }
    /**
     * Gets the request duration in milliseconds.
     */
    get durationMs() {
        return this.data.durationMs;
    }
    /**
     * Gets the HTTP-style status code from response (if applicable).
     */
    get status() {
        return this.data.status;
    }
    /**
     * Gets the error message from response (if applicable).
     */
    get responseError() {
        return this.data.responseError;
    }
    /**
     * Gets the response data (if applicable).
     */
    get responseData() {
        return this.data.responseData;
    }
    /**
     * Creates a new ActorClientRequestError.
     *
     * @param message - The error message.
     * @param data - Request-scoped error data.
     */
    constructor(message, data) {
        super(message, data);
        this.name = 'ActorClientRequestError';
    }
}
//# sourceMappingURL=ActorClientRequestError.js.map